import { Fragment, h } from "preact";

const FilterList = ({ filterList, toggleFilterOption }) => {
  const handleClick = (event, item) => {
    event.stopPropagation();
    toggleFilterOption(item, event.target.checked ? true : false, event);
  };

  return (
    <div className="filter__list">
      <div className="collection-drawer__options">
        <h6 className="filter-title">{filterList.label}</h6>
        {filterList?.values.map((item) => (
          <div
            class={`filter__option checkbox filter__option--${
              item.id.includes("filter.v.option.color") ||
              item.id.includes("filter.p.m.custom.filter_color")
                ? "color"
                : "default"
            }`}
          >
            <input
              type="checkbox"
              id={item.id}
              onChange={(event) => {
                handleClick(event, item);
              }}
              checked={item.isChecked}
            />
            {(item.id.includes("filter.v.option.color") ||
              item.id.includes("filter.p.m.custom.filter_color")) && (
              <div class="filter__option__swatch">
                <img
                  src={`${window.cdn.fileUrl}/color-${handleize(
                    item.label
                  )}.png`}
                  alt={item.label}
                />
              </div>
            )}
            <label className="text" htmlFor={item.id}>
              {item.label} {/* ({item.count}) */}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterList;
